import React, { useEffect, useState } from "react";
import { Card, Container } from 'reactstrap'
import { Table } from 'antd'

const QuizzesTab = ({ data }) => {
  const [studentQuizResult, setStudentQuizResult] = useState();
  const quizzesColumn = [
    {
      title: "SUBJECT",
      dataIndex: "name",
    },
    {
      title: "QUIZ",
      dataIndex: "category",
    },
    {
      title: "MARKS",
      dataIndex: "marks",
      render: (marks) => (Math.round(marks))
    },
    {
      title: "STATUS",
      dataIndex: "marks",
      render: (marks) => (marks > 60 ? "Pass" : "Fail"),
    },
  ]

  useEffect(() => {
    const res = data?.result;
    if (res) {
      setStudentQuizResult(res)
    }
  }, [data]);

  return (
    <div>
      {studentQuizResult ? (
        <Container fluid={true} className="dashboard-default">
          <Card className='p-3' style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ marginBottom: '100px' }} className='ant-design-table not-margin'>
              <Table
                rowClassName={(record) => record ? 'table-row-text' : ''}
                //loading={loading}
                columns={quizzesColumn}
                dataSource={studentQuizResult}
                bordered={true}
                pagination={false}
              />
            </div>
          </Card>
        </Container>
      ) : (
        <h4>
          No Quiz Attempted Yet...
        </h4>
      )}
    </div>
  );

};

export default QuizzesTab;
